<template>
  <div>
    <transition name="drawer-fade">
      <div v-if="visible" class="custom-drawer-wrapper">
        <div class="drawer-overlay" @click="handleClose"></div>
        <div class="drawer-container">
          <div class="drawer-custom-header">
            <i class="el-icon-close close-btn" @click="handleClose"></i>
            <span class="header-title">{{ petDetail.name || '寵物資訊' }}</span>
          </div>

          <div class="pet-side-panel">
            <el-tabs v-model="activeTab" stretch class="pet-side-panel__tabs">
              <el-tab-pane v-for="tab in availableTabs" :key="tab.name" :label="tab.label" :name="tab.name" />
            </el-tabs>

            <div class="pet-side-panel__content">
              <!-- 寵物資訊 Tab -->
              <template v-if="activeTab === 'information'">
                <div v-loading="isLoading" class="pet-info-section">
                  <!-- 編輯模式 -->
                  <template v-if="isEditMode">
                    <div class="pet-info-edit">
                      <el-form ref="petForm" :model="editForm" :rules="submitRules" label-position="top">
                        <!-- 頭像上傳 -->
                        <el-form-item prop="avatar" class="pet-avatar-upload">
                          <BaseUpload v-model="editForm.avatar" resource="pet" circle dir="pet" :limit-size="10" />
                        </el-form-item>

                        <el-row :gutter="16">
                          <el-col :span="12">
                            <el-form-item label="寵物名" prop="name">
                              <el-input v-model="editForm.name" placeholder="請輸入寵物名" />
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="性別" prop="gender">
                              <el-select v-model="editForm.gender" placeholder="請選擇性別" class="w-full">
                                <el-option label="公" value="male" />
                                <el-option label="母" value="female" />
                              </el-select>
                            </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row :gutter="16">
                          <el-col :span="12">
                            <el-form-item label="類別" prop="categoryId">
                              <el-select v-model="editForm.categoryId" placeholder="請選擇類別" class="w-full" @change="onCategoryChange">
                                <el-option v-for="cat in categories" :key="cat.id" :label="cat.title" :value="cat.id" />
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="體型" prop="sizeId">
                              <el-select v-model="editForm.sizeId" :placeholder="editForm.categoryId ? '請選擇體型' : '請先選擇類別'" class="w-full">
                                <el-option v-for="size in sizeOptions" :key="size.id" :label="size.title" :value="size.id" />
                              </el-select>
                            </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row :gutter="16">
                          <el-col :span="12">
                            <el-form-item label="品種">
                              <el-input v-model="editForm.breed" placeholder="請輸入品種" />
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="生日" prop="birthday">
                              <el-date-picker v-model="editForm.birthday" type="date" placeholder="選擇日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" class="w-full" />
                            </el-form-item>
                          </el-col>
                        </el-row>

                        <!-- 寵物問題編輯部分 -->
                        <div class="pet-questions-edit">
                          <div class="section-title">寵物問題</div>

                          <!-- 個性 -->
                          <div class="question-group">
                            <div class="question-label">個性</div>
                            <el-checkbox-group v-model="editForm.questions.personality" class="question-checkboxes">
                              <el-checkbox label="粘人" />
                              <el-checkbox label="膽小" />
                              <el-checkbox label="親人" />
                              <el-checkbox label="活潑" />
                              <el-checkbox label="怕生" />
                              <el-checkbox label="討厭同類" />
                              <el-checkbox label="其他" />
                            </el-checkbox-group>
                            <div class="simple-input-row" style="margin-top: 12px;">
                              <div class="simple-input-item">
                                <el-input v-model="editForm.questions.personalityOther" placeholder="其他個性補充說明" />
                              </div>
                            </div>
                          </div>

                          <!-- 健康狀況 -->
                          <div class="question-group">
                            <div class="question-label">健康狀況</div>
                            <div class="healthy-notice">
                              飼主應盡告知義務，若因隱瞞病況發生意外或死亡，經法定程序判定店家無疏失，店家不須負損害賠償責任
                            </div>
                            <div class="healthy-checkboxes">
                              <div class="checkbox-item">
                                <el-checkbox v-model="editForm.questions.healthy" label="無，狀態良好" />
                              </div>
                              <div class="checkbox-item">
                                <el-checkbox v-model="editForm.questions.healthy" label="心臟病" />
                              </div>
                              <div class="checkbox-item">
                                <el-checkbox v-model="editForm.questions.healthy" label="氣喘" />
                              </div>
                              <div class="checkbox-item">
                                <el-checkbox v-model="editForm.questions.healthy" label="氣管塌陷" />
                              </div>
                              <div class="checkbox-item">
                                <el-checkbox v-model="editForm.questions.healthy" label="白內障" />
                              </div>
                              <div class="checkbox-item">
                                <el-checkbox v-model="editForm.questions.healthy" label="癲癇" />
                              </div>
                              <div class="checkbox-item">
                                <el-checkbox v-model="editForm.questions.healthy" label="心絲蟲" />
                              </div>
                              <div class="checkbox-item">
                                <el-checkbox v-model="editForm.questions.healthy" label="艾利希體" />
                              </div>
                              <div class="checkbox-item">
                                <el-checkbox v-model="editForm.questions.healthy" label="腹膜炎" />
                              </div>
                              <div class="checkbox-item">
                                <el-checkbox v-model="editForm.questions.healthy" label="腹積水" />
                              </div>
                              <div class="checkbox-item">
                                <el-checkbox v-model="editForm.questions.healthy" label="手術外傷未癒合" />
                              </div>
                              <div class="checkbox-item">
                                <el-checkbox v-model="editForm.questions.healthy" label="髖關節問題" />
                              </div>
                              <div class="checkbox-item">
                                <el-checkbox v-model="editForm.questions.healthy" label="骨折" />
                              </div>
                              <div class="checkbox-item">
                                <el-checkbox v-model="editForm.questions.healthy" label="腸炎" />
                              </div>
                              <div class="checkbox-item">
                                <el-checkbox v-model="editForm.questions.healthy" label="血便" />
                              </div>
                              <div class="checkbox-item">
                                <el-checkbox v-model="editForm.questions.healthy" label="血尿" />
                              </div>
                              <div class="checkbox-item">
                                <el-checkbox v-model="editForm.questions.healthy" label="懷孕" />
                              </div>
                              <div class="checkbox-item">
                                <el-checkbox v-model="editForm.questions.healthy" label="傳染性疾病" />
                              </div>
                              <div class="checkbox-item">
                                <el-checkbox v-model="editForm.questions.healthy" label="其他" />
                              </div>
                            </div>
                            <div class="simple-input-row" style="margin-top: 12px;">
                              <div class="simple-input-item">
                                <el-input v-model="editForm.questions.healthyOther" placeholder="其他疾病補充說明" />
                              </div>
                            </div>
                          </div>

                          <!-- 行為 -->
                          <div class="question-group">
                            <div class="question-label">行為</div>
                            <div class="behavior-list">
                              <div class="behavior-row">
                                <el-checkbox v-model="editForm.questions.behavior" label="分離焦慮症" />
                                <el-input v-model="editForm.questions.behaviorDetails.separationAnxiety" placeholder="補充說明" class="behavior-input" />
                              </div>
                              <div class="behavior-row">
                                <el-checkbox v-model="editForm.questions.behavior" label="攻擊過家人" />
                                <el-input v-model="editForm.questions.behaviorDetails.attackFamily" placeholder="補充說明" class="behavior-input" />
                              </div>
                              <div class="behavior-row">
                                <el-checkbox v-model="editForm.questions.behavior" label="攻擊過陌生人" />
                                <el-input v-model="editForm.questions.behaviorDetails.attackStranger" placeholder="補充說明" class="behavior-input" />
                              </div>
                              <div class="behavior-row">
                                <el-checkbox v-model="editForm.questions.behavior" label="攻擊其他動物" />
                                <el-input v-model="editForm.questions.behaviorDetails.attackAnimal" placeholder="補充說明" class="behavior-input" />
                              </div>
                              <div class="behavior-row">
                                <el-checkbox v-model="editForm.questions.behavior" label="害怕特定事物" />
                                <el-input v-model="editForm.questions.behaviorDetails.fearThings" placeholder="補充說明" class="behavior-input" />
                              </div>
                              <div class="behavior-row">
                                <el-checkbox v-model="editForm.questions.behavior" label="其他" />
                                <el-input v-model="editForm.questions.behaviorDetails.other" placeholder="補充說明" class="behavior-input" />
                              </div>
                            </div>
                          </div>

                          <!-- 疫苗 -->
                          <div class="question-group">
                            <div class="question-label">疫苗</div>
                            <el-radio-group v-model="editForm.questions.vaccine" class="question-radios">
                              <el-radio :label="0">無</el-radio>
                              <el-radio :label="1">1 劑</el-radio>
                              <el-radio :label="2">2 劑</el-radio>
                              <el-radio :label="3">3 劑</el-radio>
                            </el-radio-group>
                          </div>
                        </div>

                        <div class="pet-info-actions">
                          <el-button round style="width: 100px" @click="cancelEdit">取消</el-button>
                          <el-button type="primary" round style="width: 100px" :loading="isSaving" @click="savePet">儲存</el-button>
                        </div>
                      </el-form>
                    </div>
                  </template>

                  <!-- 顯示模式 -->
                  <template v-else>
                    <div class="pet-info-display">
                      <!-- 頭像和基本資訊 -->
                      <div class="pet-info-header">
                        <div class="pet-avatar-container" :style="petAvatarStyle"></div>
                        <div class="pet-info-basic">
                          <div class="pet-name">{{ petDetail.name || '-' }}</div>
                          <div class="pet-category">{{ petCategoryText }}</div>
                        </div>
                        <el-button v-if="petDetail.id" type="primary" icon="el-icon-edit" size="small" round plain @click="startEdit">
                          編輯
                        </el-button>
                      </div>

                      <!-- 詳細資訊 -->
                      <div class="pet-info-details">
                        <el-row :gutter="16">
                          <el-col :span="12">
                            <div class="info-item">
                              <div class="info-label">性別</div>
                              <div class="info-value">{{ genderText }}</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="info-item">
                              <div class="info-label">品種</div>
                              <div class="info-value">{{ petDetail.breed || '-' }}</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="info-item">
                              <div class="info-label">體型</div>
                              <div class="info-value">{{ petDetail.sizeTitle || petDetail.size || '-' }}</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="info-item">
                              <div class="info-label">生日</div>
                              <div class="info-value">{{ birthdayText }}</div>
                            </div>
                          </el-col>
                        </el-row>
                      </div>

                      <div class="pet-info-details">
                        <div class="section-title">寵物問題</div>
                        <el-row :gutter="12">
                          <el-col :xs="24" :sm="12">
                            <div class="info-item">
                              <div class="info-label">個性</div>
                              <div class="info-value">
                                <div>{{ personalityText }}</div>
                                <div v-if="petDetail.questions && petDetail.questions.personalityOther" class="info-detail-note"> 其他: {{ petDetail.questions.personalityOther }} </div>
                              </div>
                            </div>
                          </el-col>
                          <el-col :xs="24" :sm="12">
                            <div class="info-item">
                              <div class="info-label">健康狀況</div>
                              <div class="info-value">
                                <div>{{ healthyText }}</div>
                                <div v-if="petDetail.questions && petDetail.questions.healthyOther" class="info-detail-note"> 其他: {{ petDetail.questions.healthyOther }} </div>
                              </div>
                            </div>
                          </el-col>
                          <el-col :xs="24">
                            <div class="info-item">
                              <div class="info-label">行為</div>
                              <div class="info-value">
                                <div v-if="behaviorDisplayList.length" class="behavior-display">
                                  <div v-for="item in behaviorDisplayList" :key="item.label" class="behavior-display-item">
                                    <span class="behavior-label">{{ item.label }}</span>
                                    <span v-if="item.detail" class="behavior-detail">{{ item.detail }}</span>
                                  </div>
                                </div>
                                <div v-else>未填寫</div>
                              </div>
                            </div>
                          </el-col>
                          <el-col :xs="24" :sm="12">
                            <div class="info-item">
                              <div class="info-label">疫苗</div>
                              <div class="info-value">{{ vaccineText }}</div>
                            </div>
                          </el-col>
                        </el-row>
                      </div>

                      <div class="pet-note-section">
                        <div class="pet-note-header">
                          <div class="section-title">寵物備註</div>
                          <template v-if="!isNoteEditMode">
                            <el-button type="text" icon="el-icon-plus" @click="startEditNote">新增備註</el-button>
                          </template>
                        </div>

                        <!-- 編輯新備註的表單 -->
                        <template v-if="isNoteEditMode">
                          <div class="note-edit-form">
                            <el-input v-model="noteDraft" type="textarea" :rows="4" placeholder="請輸入備註" />
                            <div class="pet-info-actions">
                              <el-button round @click="cancelEditNote">取消</el-button>
                              <el-button type="primary" round :loading="isNoteSaving" @click="saveNote">{{ editingNoteId ? '更新備註' : '新增備註' }}</el-button>
                            </div>
                          </div>
                        </template>

                        <!-- 備註列表 -->
                        <div v-loading="isLoadingNotes" class="notes-list">
                          <template v-if="petNotesList.length">
                            <ul>
                              <li v-for="(item, index) in petNotesList" :key="index" class="note-item">
                                <div class="note-content" v-html="formatContent(item.content)"></div>
                                <div class="d-flex mt-3 justify-content-between flex-lg-nowrap flex-wrap">
                                  <div class="note-meta">-{{ item.updatedAt | formatDate() }} {{ item.creator.name }}</div>
                                  <div class="note-actions">
                                    <el-button type="text" size="small" style="color:#EA6A2A" icon="el-icon-edit" @click="startEditExistingNote(item)">編輯</el-button>
                                    <el-button type="text" size="small" style="color:#EA6A2A" icon="el-icon-delete" @click="deleteNote(item.id)">刪除</el-button>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </template>
                          <template v-else>
                            <div class="no-notes">暫無備註</div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </template>

              <!-- 歷史紀錄 Tab -->
              <template v-if="activeTab === 'service'">
                <div v-loading="isLoadingRecords" class="service-records">
                  <div v-if="historyRecordsSorted.length === 0" class="empty-state">
                    <div class="empty-icon">📋</div>
                    <div class="empty-text">暫無歷史紀錄</div>
                  </div>
                  <div v-else class="records-list">
                    <div v-for="record in historyRecordsSorted" :key="`history-${record.id}`" class="record-item">
                      <div v-if="formatServiceQuestions(record.questions)" class="record-content record-content--question">
                        {{ formatServiceQuestions(record.questions) }}
                      </div>

                      <div v-if="record.content" class="record-content" v-html="formatContent(record.content)"></div>

                      <!-- 圖片 -->
                      <div v-if="record.images && record.images.length" class="record-images">
                        <el-image v-for="(img, idx) in record.images" :key="idx" :src="img" :preview-src-list="record.images" class="record-image" fit="cover" />
                      </div>

                      <!-- 文件 -->
                      <div v-if="record.normalizedFiles && record.normalizedFiles.length" class="record-files">
                        <div v-for="(file, idx) in record.normalizedFiles" :key="idx" class="record-file">
                          <i class="el-icon-document" />
                          <a :href="file.url" target="_blank" class="file-name">{{ file.name || '附件檔案' }}</a>
                        </div>
                      </div>

                      <div class="record-footer">
                        <div class="record-meta">-{{ formatDate(record.updatedAt || record.createdAt) }} {{ (record.creator && record.creator.name) || '-' }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <!-- 服務紀錄 Tab (當前訂單 + 當前寵物) -->
              <template v-if="activeTab === 'currentService'">
                <div v-loading="isLoadingCurrentRecords" class="current-service-records">
                  <div v-if="!orderId" class="empty-state">
                    <div class="empty-icon">📝</div>
                    <div class="empty-text">請先儲存並確認訂單後，才能查看服務紀錄</div>
                  </div>
                  <div v-else>
                    <div class="service-records-header">
                      <div class="section-title">此筆訂單服務紀錄</div>
                      <el-button type="text" icon="el-icon-plus" @click="openNewServiceRecordDrawer">新增服務紀錄</el-button>
                    </div>
                    <div v-if="currentServiceRecordsSorted.length === 0" class="empty-state">
                      <div class="empty-icon">🧾</div>
                      <div class="empty-text">此寵物在本訂單暫無服務紀錄</div>
                    </div>
                    <div v-else class="records-list">
                      <div v-for="record in currentServiceRecordsSorted" :key="`current-${record.id}`" class="record-item">
                        <div v-if="formatServiceQuestions(record.questions)" class="record-content record-content--question">
                          {{ formatServiceQuestions(record.questions) }}
                        </div>

                        <div v-if="record.content" class="record-content" v-html="formatContent(record.content)"></div>

                        <div v-if="record.images && record.images.length" class="record-images">
                          <el-image v-for="(img, idx) in record.images" :key="idx" :src="img" :preview-src-list="record.images" class="record-image" fit="cover" />
                        </div>

                        <div v-if="record.normalizedFiles && record.normalizedFiles.length" class="record-files">
                          <div v-for="(file, idx) in record.normalizedFiles" :key="idx" class="record-file">
                            <i class="el-icon-document" />
                            <a :href="file.url" target="_blank" class="file-name">{{ file.name || '附件檔案' }}</a>
                          </div>
                        </div>

                        <div class="record-footer">
                          <div class="record-meta">-{{ formatDate(record.updatedAt || record.createdAt) }} {{ (record.creator && record.creator.name) || '-' }}</div>
                          <div class="record-actions">
                            <el-button type="text" size="small" style="color:#EA6A2A" icon="el-icon-edit" @click="openEditServiceRecordDrawer(record)">編輯</el-button>
                            <el-button type="text" size="small" style="color:#EA6A2A" icon="el-icon-delete" @click="deleteServiceRecord(record.id)">刪除</el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- 新增/編輯服務紀錄 Drawer -->
    <transition name="drawer-fade">
      <div v-if="isServiceRecordDrawerVisible" class="custom-drawer-wrapper">
        <div class="drawer-overlay" @click="handleServiceRecordDrawerClosed"></div>
        <div class="drawer-container">
          <div class="drawer-custom-header">
            <i class="el-icon-close close-btn" @click="handleServiceRecordDrawerClosed"></i>
            <span class="header-title">{{ serviceRecordMode === 'new' ? '新增服務紀錄' : '編輯服務紀錄' }}</span>
          </div>

          <div class="pet-side-panel">
            <div class="pet-side-panel__content" style="margin-bottom: 40px;">
              <el-form ref="serviceRecordForm" :model="serviceRecordSubmitData" :rules="serviceRecordSubmitRules" label-position="top" :validate-on-rule-change="false">
                <!-- 圖片上傳 -->
                <el-form-item label="">
                  <ImageUpload
                    ref="serviceRecordUpload"
                    v-model="serviceRecordSubmitData.images"
                    :trying-save.sync="serviceRecordTryingSave"
                    :file-list="serviceRecordFileList"
                    :show-upload="true"
                    @updateFileList="updateServiceRecordFileList"
                  />
                </el-form-item>

                <!-- 文件上傳 -->
                <el-form-item label="">
                  <FileUpload ref="serviceRecordFileUpload" :external-file-list.sync="serviceRecordExternalFileList" @emitCleanExternal="handleExternalWithoutCache" />
                </el-form-item>
                <!-- 備註 -->
                <el-form-item label="備註" prop="content">
                  <el-input v-model="serviceRecordSubmitData.content" type="textarea" :autosize="{ minRows: 3 }" class="bg-white is-border" />
                </el-form-item>
              </el-form>

              <div class="btn-group-inline">
                <el-button plain class="is-round" @click="handleServiceRecordDrawerClosed">取消</el-button>
                <el-button :loading="serviceRecordTryingSave" :disabled="serviceRecordTryingSave" class="is-round" type="primary" @click="handleSaveServiceRecord">儲存</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import moment from 'moment'
import BaseUpload from '@components/BaseUpload'
import lazyLoadComponent from '@router/lazyload-component'
import { cloneDeep } from 'lodash'
import { getPetHistoryComments, getHotelOrderPetComments, createHotelOrderPetComment, updateHotelOrderPetComment, deleteHotelOrderPetComment } from '@/src/apis'

export default {
  name: 'PetSidePanelPartial',
  components: {
    BaseUpload,
    ImageUpload: () => lazyLoadComponent(import('@components/ImageUpload')),
    FileUpload: () => lazyLoadComponent(import('@components/FileUpload.vue')),
  },
  filters: {
    formatDate(date) {
      return moment(date).isValid() ? moment(date).format('YYYY/MM/DD HH:mm') : '-'
    },
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    petDetail: {
      type: Object,
      default: () => ({}),
    },
    initialTab: {
      type: String,
      default: 'information',
    },
    orderId: {
      type: [String, Number],
      default: null,
    },
    commentType: {
      type: String,
      default: 'pet', // 'pet' or 'order'
    },
    mode: {
      type: String,
      default: 'view', // 'create' (建立訂單) or 'view' (查看訂單)
    },
  },
  data() {
    return {
      activeTab: 'information',
      isEditMode: false,
      isLoading: false,
      isSaving: false,
      isNoteSaving: false,
      isNoteEditMode: false,
      isLoadingRecords: false,
      isLoadingCurrentRecords: false,
      categories: [],
      editForm: {
        id: null,
        memberId: null,
        avatar: '',
        name: '',
        categoryId: '',
        sizeId: '',
        breed: '',
        gender: '',
        birthday: '',
        weight: '',
        note: '',
        questions: {
          personality: [],
          personalityOther: '',
          healthy: [],
          healthyOther: '',
          behavior: [],
          behaviorDetails: {
            separationAnxiety: '',
            attackFamily: '',
            attackStranger: '',
            attackAnimal: '',
            fearThings: '',
            other: '',
          },
          vaccine: 0,
        },
      },
      serviceRecords: [],
      currentServiceRecords: [],
      petNotesList: [],
      noteDraft: '',
      editingNoteId: null,
      serviceRecordDraft: '',
      editingServiceRecordId: null,
      editingServiceRecordOrderNo: null,
      isServiceRecordSaving: false,
      isLoadingNotes: false,
      // 新增服務紀錄相關
      isServiceRecordDrawerVisible: false,
      serviceRecordMode: 'new', // 'new' or 'edit'
      serviceRecordSubmitData: {
        images: [],
        content: '',
        uuid: '',
        questions: {
          afterOrderOption: [null, null, null, null, []],
          afterOrder: [],
          handle: [],
        },
      },
      serviceRecordDefaultValue: {
        images: [],
        content: '',
        uuid: '',
        questions: {
          afterOrderOption: [null, null, null, null, []],
          afterOrder: [],
          handle: [],
        },
      },
      serviceRecordFileList: [],
      serviceRecordExternalFileList: [],
      serviceRecordExternalWithoutCache: [],
      serviceRecordTryingSave: false,
      dingBeautyNotShow: window.globalData && window.globalData.APP_TYPE !== 'dingbeauty',
    }
  },
  computed: {
    submitRules() {
      // 允許只更新單一欄位（例如只改備註/只換頭貼）
      return {}
    },
    serviceRecordSubmitRules() {
      return {
        content: [
          {
            required: this.serviceRecordFileList.length === 0 && this.serviceRecordExternalFileList.length === 0,
            message: '請填寫備註，或上傳圖片/文件',
          },
        ],
      }
    },
    sizeOptions() {
      const cat = this.categories.find((c) => c.id === this.editForm.categoryId)
      return cat && cat.children ? cat.children : []
    },
    petAvatar() {
      return this.petDetail.avatar || this.petDetail.imgUrl || ''
    },
    petCategoryText() {
      const pet = this.petDetail
      const category = pet.category && typeof pet.category === 'object' ? pet.category : null
      const title = (category && category.title) || pet.categoryTitle || '-'
      const tags = (category && category.tags) || pet.categoryTags || []
      if (tags.length) {
        return `${title} | ${tags.join(' | ')}`
      }
      return title
    },
    genderText() {
      if (this.petDetail.gender === 'male') return '公'
      if (this.petDetail.gender === 'female') return '母'
      return '-'
    },
    birthdayText() {
      if (!this.petDetail.birthday) return '-'
      return moment(this.petDetail.birthday).isValid() ? moment(this.petDetail.birthday).format('YYYY/MM/DD') : this.petDetail.birthday
    },
    orderData() {
      return {
        id: this.orderId,
        uuid: this.orderId,
        pet: this.petDetail,
        petId: this.petDetail.id,
      }
    },
    petAvatarStyle() {
      if (this.petAvatar) {
        return {
          backgroundImage: `url('${this.petAvatar}')`,
        }
      }
      // 使用預設背景圖片
      const defaultBg = this.$appType && this.$appType() === 'ipetbooking' ? require('@assets/images/pet-avatar-default@2x.png') : require('@assets/images/person_background.svg')
      return {
        backgroundImage: `url('${defaultBg}')`,
      }
    },

    personalityText() {
      // personality 保存为 string 数组，直接 join
      if (!this.petDetail || typeof this.petDetail !== 'object') return '未填寫'
      const questions = this.petDetail.questions || {}
      if (!questions.hasOwnProperty('personality') || !Array.isArray(questions.personality)) return '未填寫'

      const personalities = questions.personality.filter((item) => item && typeof item === 'string')
      return personalities.length ? personalities.join('，') : '未填寫'
    },
    healthyText() {
      if (!this.petDetail || typeof this.petDetail !== 'object') return '未填寫'
      if (!this.petDetail.questions || !Array.isArray(this.petDetail.questions.healthy)) return '未填寫'
      return this.formatQuestionList(this.petDetail.questions.healthy, 'healthy')
    },
    behaviorText() {
      if (!this.petDetail || typeof this.petDetail !== 'object') return '未填寫'
      if (!this.petDetail.questions || !Array.isArray(this.petDetail.questions.behavior)) return '未填寫'
      return this.formatQuestionList(this.petDetail.questions.behavior, 'behavior')
    },
    behaviorDisplayList() {
      try {
        // 参考 PetList 的防守性检查
        if (!this.petDetail || typeof this.petDetail !== 'object') return []
        const questions = this.petDetail.questions || {}
        if (!questions.hasOwnProperty('behavior') || !Array.isArray(questions.behavior)) return []

        const rawBehaviors = questions.behavior
        const behaviors = this.normalizeQuestionSelections(rawBehaviors, 'behavior')
        const details = (questions && questions.behaviorDetails) || {}
        const behaviorMapping = {
          分離焦慮症: 'separationAnxiety',
          攻擊過家人: 'attackFamily',
          攻擊過陌生人: 'attackStranger',
          攻擊其他動物: 'attackAnimal',
          害怕特定事物: 'fearThings',
          其他: 'other',
          攻擊陌生人: 'attackStranger',
          攻擊過同類: 'attackAnimal',
          被同類咬過: 'fearThings',
        }
        const legacyTextMap = {}
        ;(Array.isArray(rawBehaviors) ? rawBehaviors : []).forEach((item) => {
          if (!item || typeof item !== 'object') return
          const label = this.resolveQuestionLabel(item)
          if (!label) return
          if (item.text !== null && item.text !== undefined && item.text !== '') {
            legacyTextMap[label] = String(item.text)
          }
        })
        return behaviors.map((label) => {
          const key = behaviorMapping[label]
          const detail = (details && typeof details === 'object' && details[key]) || legacyTextMap[label] || ''
          return {
            label,
            detail: String(detail),
          }
        })
      } catch (error) {
        console.error('Error in behaviorDisplayList:', error)
        return []
      }
    },
    vaccineText() {
      // 参考 PetList 的防守性检查方式
      if (!this.petDetail || typeof this.petDetail !== 'object') return '未填寫'
      const questions = this.petDetail.questions || {}
      if (!questions.hasOwnProperty('vaccine')) return '未填寫'

      const vaccine = questions.vaccine
      // 使用 switch，和 PetList 一样处理
      switch (Number(vaccine)) {
        case 1:
          return '1 劑'
        case 2:
          return '2 劑'
        case 3:
          return '3 劑'
        default:
          return '無'
      }
    },
    historyRecordsSorted() {
      return [...this.serviceRecords].sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0))
    },
    currentServiceRecordsSorted() {
      return [...this.currentServiceRecords].sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0))
    },
    // 根據mode過濾顯示tabs
    availableTabs() {
      const allTabs = [{ label: '寵物資訊', name: 'information' }, { label: '歷史紀錄', name: 'service' }, { label: '服務紀錄', name: 'currentService' }]
      // 建立訂單模式不顯示服務紀錄tab
      if (this.mode === 'create') {
        return allTabs.filter((tab) => tab.name !== 'currentService')
      }
      return allTabs
    },
  },
  watch: {
    initialTab: {
      immediate: true,
      handler(val) {
        if (['information', 'service', 'currentService'].includes(val)) {
          this.activeTab = val
        }
      },
    },
    activeTab(val) {
      // 當用戶手動切換tab或程序設置activeTab時加載數據
      if (val === 'service') {
        this.fetchServiceRecords()
      }
      if (val === 'currentService') {
        this.fetchCurrentServiceRecords()
      }
    },
    'petDetail.id': {
      immediate: true,
      handler(val) {
        if (val) {
          // 确保 questions 字段都存在（参考 PetList 的 tryToFetchSinglePet）
          const targetFields = ['personality', 'healthy', 'behavior']
          if (this.petDetail.questions && typeof this.petDetail.questions === 'object') {
            targetFields.forEach((field) => {
              if (!this.petDetail.questions.hasOwnProperty(field)) {
                this.$set(this.petDetail.questions, field, [])
              }
            })
            if (!this.petDetail.questions.hasOwnProperty('vaccine')) {
              this.$set(this.petDetail.questions, 'vaccine', 0)
            }
          }

          this.syncEditForm()
          this.noteDraft = ''
          this.isNoteEditMode = false
          this.cancelEditServiceRecord()
          this.fetchPetNotes()
          // 當寵物ID改變時，延遲加載以確保 initialTab watch 已執行
          this.$nextTick(() => {
            if (this.activeTab === 'service') {
              this.fetchServiceRecords()
            }
            if (this.activeTab === 'currentService') {
              this.fetchCurrentServiceRecords()
            }
          })
        }
      },
    },
    orderId() {
      if (this.activeTab === 'currentService') {
        this.fetchCurrentServiceRecords()
      }
    },
  },
  created() {
    this.fetchCategories()
    this.syncEditForm()
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    async fetchCategories() {
      try {
        this.categories = await this.$store.dispatch('product/fetchServiceCategory', { paginate: 0 })
      } catch (error) {
        console.error('Failed to fetch categories:', error)
        this.categories = []
      }
    },
    async fetchPetNotes() {
      if (!this.petDetail.id) {
        this.petNotesList = []
        return
      }

      try {
        this.isLoadingNotes = true
        this.petNotesList = await this.$store.dispatch('comment/fetchList', {
          paginate: 0,
          type: 'pet',
          petId: this.petDetail.id,
        })
      } catch (error) {
        console.error('Failed to fetch pet notes:', error)
        this.petNotesList = []
      } finally {
        this.isLoadingNotes = false
      }
    },
    async fetchServiceRecords() {
      if (!this.petDetail.id) {
        this.serviceRecords = []
        return
      }

      try {
        this.isLoadingRecords = true
        const response = await getPetHistoryComments(this.petDetail.id, { paginate: 0 })
        console.log('History comments response:', response)
        // 嘗試多種數據路徑
        const records = response.items || response.data?.items || response.data?.data?.items || []
        console.log('Parsed records:', records)
        this.serviceRecords = records.map(this.normalizeRecord)
      } catch (error) {
        console.error('Failed to fetch service records:', error)
        this.serviceRecords = []
      } finally {
        this.isLoadingRecords = false
      }
    },
    async fetchCurrentServiceRecords() {
      if (!this.petDetail.id || !this.orderId) {
        this.currentServiceRecords = []
        return
      }

      try {
        this.isLoadingCurrentRecords = true
        const response = await getHotelOrderPetComments(this.orderId, this.petDetail.id, { paginate: 0 })
        console.log('Current service records response:', response)
        // 嘗試多種數據路徑
        const records = response.items || response.data?.items || response.data?.data?.items || []
        console.log('Parsed records:', records)
        this.currentServiceRecords = records.map(this.normalizeRecord)
      } catch (error) {
        console.error('Failed to fetch current service records:', error)
        this.currentServiceRecords = []
      } finally {
        this.isLoadingCurrentRecords = false
      }
    },
    normalizeRecord(record) {
      const files = []
      if (Array.isArray(record.files)) {
        record.files.forEach((item) => {
          if (typeof item === 'string') {
            files.push({ name: '附件檔案', url: item })
            return
          }
          if (item && (item.url || item.path)) {
            files.push({
              name: item.name || item.filename || '附件檔案',
              url: item.url || item.path,
            })
          }
        })
      }
      if (Array.isArray(record.external_files)) {
        record.external_files.forEach((item) => {
          if (item && (item.url || item.path)) {
            files.push({
              name: item.name || item.filename || '附件檔案',
              url: item.url || item.path,
            })
          }
        })
      }
      return {
        ...record,
        normalizedFiles: files,
      }
    },
    formatAfterOrderQuestion(questions = {}) {
      if (!questions || !Array.isArray(questions.afterOrder) || !questions.afterOrder.length) return ''
      const options = Array.isArray(questions.afterOrderOption) ? questions.afterOrderOption : [null, null, null, null, []]
      const values = []
      questions.afterOrder.forEach((item) => {
        if (['正常', '皮膚病', '指甲流血', '剃傷'].includes(item)) {
          values.push(item)
          return
        }
        if (item === '跳蚤') values.push(options[0] ? `跳蚤(${options[0]})` : '跳蚤')
        if (item === '璧蝨') values.push(options[1] ? `璧蝨(${options[1]})` : '璧蝨')
        if (item === '耳炎') values.push(options[2] ? `耳炎(${options[2]})` : '耳炎')
        if (item === '耳疥') values.push(options[3] ? `耳疥(${options[3]})` : '耳疥')
        if (item === '眼睛') {
          const eye = Array.isArray(options[4]) && options[4].length ? `眼睛(${options[4].join(',')})` : '眼睛'
          values.push(eye)
        }
      })
      return values.join('，')
    },
    formatServiceQuestions(questions = {}) {
      if (!questions || typeof questions !== 'object') return ''
      const blocks = []
      const afterOrder = this.formatAfterOrderQuestion(questions)
      if (afterOrder) blocks.push(`美容狀況：${afterOrder}`)
      if (Array.isArray(questions.handle) && questions.handle.length) {
        blocks.push(`處置方式：${questions.handle.join('，')}`)
      }
      return blocks.join('｜')
    },
    extractPersonalityTitles(list) {
      // personality 已经是 string 数组，直接返回
      if (!Array.isArray(list)) return []
      return list.filter((item) => item && typeof item === 'string')
    },
    ensureQuestionFields(petQuestions) {
      // 确保所有 question 字段都存在（参考 PetList 的做法）
      const targetFields = ['personality', 'healthy', 'behavior']
      targetFields.forEach((field) => {
        if (!petQuestions.hasOwnProperty(field)) {
          this.$set(petQuestions, field, [])
        }
      })
      if (!petQuestions.hasOwnProperty('vaccine')) {
        this.$set(petQuestions, 'vaccine', 0)
      }
      return petQuestions
    },
    syncEditForm() {
      const pet = this.petDetail || {}
      let petQuestions = pet.questions || {}

      // 确保所有字段存在
      petQuestions = this.ensureQuestionFields(petQuestions)

      const legacyBehaviorDetails = this.extractBehaviorDetailsFromLegacy(petQuestions.behavior)
      this.editForm = {
        id: pet.id || null,
        memberId: pet.memberId || null,
        avatar: pet.avatar || pet.imgUrl || '',
        name: pet.name || '',
        categoryId: pet.categoryId || (pet.category && pet.category.id) || '',
        sizeId: pet.sizeId || '',
        breed: pet.breed || '',
        gender: pet.gender || '',
        birthday: pet.birthday || '',
        weight: pet.weight || '',
        note: pet.note || '',
        questions: {
          personality: this.extractPersonalityTitles(petQuestions.personality),
          personalityOther: petQuestions.personalityOther || this.extractLegacyTextByTitle(petQuestions.personality, '其他') || '',
          healthy: this.normalizeQuestionSelections(petQuestions.healthy, 'healthy'),
          healthyOther: petQuestions.healthyOther || this.extractLegacyTextByTitle(petQuestions.healthy, '其他') || '',
          behavior: this.normalizeQuestionSelections(petQuestions.behavior, 'behavior'),
          behaviorDetails: {
            separationAnxiety: (petQuestions.behaviorDetails && petQuestions.behaviorDetails.separationAnxiety) || legacyBehaviorDetails.separationAnxiety || '',
            attackFamily: (petQuestions.behaviorDetails && petQuestions.behaviorDetails.attackFamily) || legacyBehaviorDetails.attackFamily || '',
            attackStranger: (petQuestions.behaviorDetails && petQuestions.behaviorDetails.attackStranger) || legacyBehaviorDetails.attackStranger || '',
            attackAnimal: (petQuestions.behaviorDetails && petQuestions.behaviorDetails.attackAnimal) || legacyBehaviorDetails.attackAnimal || '',
            fearThings: (petQuestions.behaviorDetails && petQuestions.behaviorDetails.fearThings) || legacyBehaviorDetails.fearThings || '',
            other: (petQuestions.behaviorDetails && petQuestions.behaviorDetails.other) || legacyBehaviorDetails.other || '',
          },
          vaccine: petQuestions.hasOwnProperty('vaccine') ? Number(petQuestions.vaccine) : 0,
        },
      }
      this.noteDraft = pet.note || ''
    },
    onCategoryChange() {
      this.editForm.sizeId = ''
    },
    startEdit() {
      this.syncEditForm()
      this.isEditMode = true
      this.$nextTick(() => {
        if (this.$refs.petForm) {
          this.$refs.petForm.clearValidate()
        }
      })
    },
    cancelEdit() {
      this.isEditMode = false
      this.syncEditForm()
    },
    async savePet() {
      if (!this.editForm.id) {
        this.$message.warning('無法儲存：缺少寵物 ID')
        return
      }

      try {
        await this.$refs.petForm.validate()
        this.isSaving = true

        const normalizedQuestions = this.buildLegacyCompatibleQuestions(this.editForm.questions)

        await this.$store.dispatch('member/storeSinglePet', {
          ...this.editForm,
          questions: normalizedQuestions,
          memberId: this.editForm.memberId || this.petDetail.memberId,
        })

        this.isEditMode = false
        this.$message.success('寵物資訊已更新')
        this.$emit('updated', { id: this.editForm.id })
      } catch (error) {
        if (error !== false) {
          console.error('Failed to save pet:', error)
          this.$message.error('儲存失敗，請稍後再試')
        }
      } finally {
        this.isSaving = false
      }
    },
    formatDate(date) {
      return moment(date).isValid() ? moment(date).format('YYYY/MM/DD HH:mm') : '-'
    },
    formatContent(content) {
      return content ? content.replace(/\n/g, '<br>') : ''
    },
    formatQuestionList(list, keyName = '') {
      if (!Array.isArray(list) || list.length === 0) return '未填寫'
      const textList = this.normalizeQuestionSelections(list, keyName)
      return textList.length ? textList.join('，') : '未填寫'
    },
    resolveQuestionLabel(item) {
      if (!item) return ''
      if (typeof item === 'string') return item.trim()
      if (typeof item === 'object') {
        const label = item.title || item.label || item.textValue || item.value || item.name || ''
        return String(label || '').trim()
      }
      return String(item).trim()
    },
    normalizeQuestionSelections(list, keyName = '') {
      if (!Array.isArray(list)) return []
      const aliasMap = {
        healthy: {
          '無/狀態良好': '無，狀態良好',
        },
        behavior: {
          攻擊陌生人: '攻擊過陌生人',
          攻擊過同類: '攻擊其他動物',
          被同類咬過: '害怕特定事物',
        },
      }
      const normalized = list
        .map((item) => {
          const label = this.resolveQuestionLabel(item)
          if (!label) return ''
          return (aliasMap[keyName] && aliasMap[keyName][label]) || label
        })
        .filter(Boolean)
      return [...new Set(normalized)]
    },
    extractLegacyTextByTitle(list, title) {
      if (!Array.isArray(list)) return ''
      const target = list.find((item) => {
        if (!item || typeof item !== 'object') return false
        return this.resolveQuestionLabel(item) === title
      })
      if (!target) return ''
      return target.text ? String(target.text) : ''
    },
    extractBehaviorDetailsFromLegacy(list) {
      const behaviorTitleToKey = {
        分離焦慮症: 'separationAnxiety',
        攻擊過家人: 'attackFamily',
        攻擊陌生人: 'attackStranger',
        攻擊過同類: 'attackAnimal',
        被同類咬過: 'fearThings',
        攻擊過陌生人: 'attackStranger',
        攻擊其他動物: 'attackAnimal',
        害怕特定事物: 'fearThings',
        其他: 'other',
      }
      const output = {
        separationAnxiety: '',
        attackFamily: '',
        attackStranger: '',
        attackAnimal: '',
        fearThings: '',
        other: '',
      }
      if (!Array.isArray(list)) return output
      list.forEach((item) => {
        if (!item || typeof item !== 'object') return
        const title = this.resolveQuestionLabel(item)
        const key = behaviorTitleToKey[title]
        if (!key) return
        output[key] = item.text ? String(item.text) : output[key]
      })
      return output
    },
    buildLegacyCompatibleQuestions(questions = {}) {
      // personality 直接用 string 数组格式（不需要 normalizeQuestionSelections）
      const personalitySelected = Array.isArray(questions.personality) ? questions.personality : []
      const healthySelected = this.normalizeQuestionSelections(questions.healthy, 'healthy')
      const behaviorSelected = this.normalizeQuestionSelections(questions.behavior, 'behavior')
      const behaviorDetails = questions.behaviorDetails || {}

      const healthyNameMap = {
        '無，狀態良好': 'none',
        心臟病: 'heart-disease',
        氣喘: 'asthma',
        氣管塌陷: 'tracheal-collapse',
        白內障: 'cataract',
        癲癇: 'epilepsy',
        心絲蟲: 'heartworm',
        艾利希體: 'ehrlichiosis',
        腹膜炎: 'peritonitis',
        腹積水: 'ascites',
        手術外傷未癒合: 'surgery-wound-not-healed',
        髖關節問題: 'hip-joint-problem',
        骨折: 'fracture',
        腸炎: 'enteritis',
        血便: 'bloody-stool',
        血尿: 'bloody-urine',
        懷孕: 'pregnant',
        傳染性疾病: 'infectious-disease',
        其他: 'other',
      }
      const behaviorNameMap = {
        分離焦慮症: 'SAD',
        攻擊過家人: 'attack-familly',
        攻擊過陌生人: 'attack-stranger',
        攻擊其他動物: 'attack-same',
        害怕特定事物: 'be-attacked',
        其他: 'other',
      }
      const behaviorDetailMap = {
        分離焦慮症: 'separationAnxiety',
        攻擊過家人: 'attackFamily',
        攻擊過陌生人: 'attackStranger',
        攻擊其他動物: 'attackAnimal',
        害怕特定事物: 'fearThings',
        其他: 'other',
      }

      const personality = personalitySelected
      const healthy = healthySelected.map((title) => ({
        title,
        name: healthyNameMap[title] || title,
        text: title === '其他' ? questions.healthyOther || null : null,
      }))
      const behaviorLegacyTitleMap = {
        攻擊過陌生人: '攻擊陌生人',
        攻擊其他動物: '攻擊過同類',
        害怕特定事物: '被同類咬過',
      }
      const behavior = behaviorSelected.map((title) => {
        const legacyTitle = behaviorLegacyTitleMap[title] || title
        return {
          title: legacyTitle,
          name: behaviorNameMap[title] || title,
          text: behaviorDetails[behaviorDetailMap[title]] || null,
        }
      })

      return {
        ...questions,
        personality,
        healthy,
        behavior,
        vaccine: typeof questions.vaccine !== 'undefined' ? Number(questions.vaccine) : 0,
      }
    },
    startEditNote() {
      this.noteDraft = ''
      this.editingNoteId = null
      this.isNoteEditMode = true
    },
    startEditServiceRecord(record) {
      this.editingServiceRecordId = record.id
      this.editingServiceRecordOrderNo = record.orderNo || null
      this.serviceRecordDraft = record.content || ''
    },
    cancelEditServiceRecord() {
      this.editingServiceRecordId = null
      this.editingServiceRecordOrderNo = null
      this.serviceRecordDraft = ''
    },
    async saveServiceRecord() {
      if (!this.editForm.id || !this.editingServiceRecordId) {
        this.$message.warning('無法更新：缺少必要資料')
        return
      }

      if (!this.serviceRecordDraft.trim()) {
        this.$message.warning('請輸入服務紀錄內容')
        return
      }

      try {
        this.isServiceRecordSaving = true
        const payload = {
          type: 'service',
          petId: this.editForm.id,
          content: this.serviceRecordDraft,
          uuid: this.editingServiceRecordId,
        }

        if (this.editingServiceRecordOrderNo || this.orderId) {
          payload.orderNo = this.editingServiceRecordOrderNo || this.orderId
        }

        await this.$store.dispatch('comment/store', payload)
        this.$message.success('服務紀錄已更新')
        this.cancelEditServiceRecord()
        await this.fetchServiceRecords()
        await this.fetchCurrentServiceRecords()
      } catch (error) {
        console.error('Failed to save service record:', error)
        this.$message.error('更新失敗，請稍後再試')
      } finally {
        this.isServiceRecordSaving = false
      }
    },
    async deleteServiceRecord(recordId) {
      if (!this.orderId) {
        this.$message.warning('無法刪除：缺少訂單資訊')
        return
      }

      try {
        await this.$confirm('確定要刪除此服務紀錄嗎？', '警告', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning',
        })

        await deleteHotelOrderPetComment(this.orderId, this.petDetail.id, recordId)

        if (this.editingServiceRecordId === recordId) {
          this.cancelEditServiceRecord()
        }
        this.$message.success('服務紀錄已刪除')
        await this.fetchCurrentServiceRecords()
      } catch (error) {
        if (error !== 'cancel') {
          console.error('Failed to delete service record:', error)
          this.$message.error('刪除失敗，請稍後再試')
        }
      }
    },
    startEditExistingNote(item) {
      this.noteDraft = item.content
      this.editingNoteId = item.id
      this.isNoteEditMode = true
    },
    cancelEditNote() {
      this.noteDraft = ''
      this.editingNoteId = null
      this.isNoteEditMode = false
    },
    async saveNote() {
      if (!this.editForm.id) {
        this.$message.warning('無法儲存：缺少寵物 ID')
        return
      }

      if (!this.noteDraft.trim()) {
        this.$message.warning('請輸入備註內容')
        return
      }

      try {
        this.isNoteSaving = true
        const isEditing = !!this.editingNoteId

        // 通過 comment/store API 新增或編輯備註
        const payload = {
          petId: this.editForm.id,
          content: this.noteDraft,
          type: 'pet',
        }

        // 如果是編輯，傳入 uuid 以標識更新現有備註而不是新增
        if (isEditing) {
          payload.uuid = this.editingNoteId
        }

        await this.$store.dispatch('comment/store', payload)
        this.noteDraft = ''
        this.editingNoteId = null
        this.isNoteEditMode = false
        this.$message.success(isEditing ? '備註已更新' : '備註已新增')

        // 重新獲取寵物資訊
        await this.refreshPetDetail()
        await this.fetchPetNotes()
        this.$emit('updated', { id: this.editForm.id })
      } catch (error) {
        console.error('Failed to save note:', error)
        this.$message.error('備註儲存失敗，請稍後再試')
      } finally {
        this.isNoteSaving = false
      }
    },
    async deleteNote(noteId) {
      try {
        await this.$confirm('確定要刪除此備註嗎？', '警告', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning',
        })

        await this.$store.dispatch('comment/removeComment', { ids: [noteId] })
        this.$message.success('備註已刪除')
        await this.fetchPetNotes()
      } catch (error) {
        if (error !== 'cancel') {
          console.error('Failed to delete note:', error)
          this.$message.error('刪除失敗，請稍後再試')
        }
      }
    },
    async refreshPetDetail() {
      if (!this.petDetail.id || !this.petDetail.memberId) return
      try {
        const pet = await this.$store.dispatch('member/fetchSinglePet', {
          memberId: this.petDetail.memberId,
          petId: this.petDetail.id,
        })
        Object.assign(this.petDetail, pet)
      } catch (error) {
        console.error('Failed to refresh pet detail:', error)
      }
    },
    // ===== 新增服務紀錄相關方法 =====
    openNewServiceRecordDrawer() {
      if (!this.orderId) {
        this.$message.warning('請先儲存並確認訂單後，才能新增服務紀錄')
        return
      }
      this.serviceRecordMode = 'new'
      this.isServiceRecordDrawerVisible = true
      this.$nextTick(() => {
        this.serviceRecordSubmitData = cloneDeep(this.serviceRecordDefaultValue)
        this.serviceRecordFileList = []
        this.serviceRecordExternalFileList = []
        this.serviceRecordExternalWithoutCache = []
      })
    },
    openEditServiceRecordDrawer(record) {
      this.serviceRecordMode = 'edit'
      this.isServiceRecordDrawerVisible = true
      if (!this.orderId) {
        // 如果沒有 orderId，使用 record 的 orderNo
      }
      this.$nextTick(() => {
        this.serviceRecordSubmitData = {
          images: record.images || [],
          content: record.content || '',
          uuid: record.id,
          questions: {
            afterOrderOption: (record.questions && record.questions.afterOrderOption) || [null, null, null, null, []],
            afterOrder: (record.questions && record.questions.afterOrder) || [],
            handle: (record.questions && record.questions.handle) || [],
          },
        }
        this.serviceRecordDefaultValue = cloneDeep(this.serviceRecordSubmitData)
        this.tryToGetFileList(this.serviceRecordSubmitData.images)
        this.serviceRecordExternalFileList = (record.external_files && cloneDeep(record.external_files)) || []
        this.serviceRecordExternalWithoutCache = (record.external_files && cloneDeep(record.external_files)) || []
      })
    },
    handleServiceRecordDrawerClosed() {
      this.removeServiceRecordExternalFile()
      this.isServiceRecordDrawerVisible = false
      this.$nextTick(() => {
        this.serviceRecordSubmitData = cloneDeep(this.serviceRecordDefaultValue)
      })
    },
    removeServiceRecordExternalFile() {
      this.serviceRecordExternalFileList = []
      if (this.$refs.serviceRecordFileUpload) {
        this.$refs.serviceRecordFileUpload.cacheList = []
      }
    },
    tryToGetFileList(images) {
      if (images.length === 0) {
        this.serviceRecordFileList = []
      } else {
        this.serviceRecordFileList = images.map((item) => {
          return {
            url: item,
          }
        })
      }
    },
    updateServiceRecordFileList(catchItem) {
      this.serviceRecordFileList = [...this.serviceRecordFileList, catchItem]
    },
    handleExternalWithoutCache(cleanExternal) {
      this.serviceRecordExternalWithoutCache = cleanExternal
    },
    extractFilename(url) {
      const full = url.split('/').pop()
      const parts = full.split('-')
      const base = parts[0]
      const ext = full.split('.').pop()
      return `${base}.${ext}`
    },
    mapExternalFiles(files) {
      return (files || []).map((url) => ({ name: this.extractFilename(url), path: url }))
    },
    async handleSaveServiceRecord() {
      if (!this.$refs.serviceRecordForm) return
      await this.$refs.serviceRecordForm.validate()
      const orderNo = this.orderId

      try {
        this.serviceRecordTryingSave = true

        // 舊圖片（非 blob）
        const oldImages = this.serviceRecordFileList.filter((item) => item.url.indexOf('blob') === -1).map((item) => item.url)

        // 建立帶型別的任務
        const uploadTasks = []

        if (this.$refs.serviceRecordUpload && this.$refs.serviceRecordUpload.cacheList && this.$refs.serviceRecordUpload.cacheList.length > 0) {
          uploadTasks.push({
            type: 'images',
            promise: this.$refs.serviceRecordUpload.handleUpload(),
          })
        }

        if (this.$refs.serviceRecordFileUpload && this.$refs.serviceRecordFileUpload.cacheList && this.$refs.serviceRecordFileUpload.cacheList.length > 0) {
          uploadTasks.push({
            type: 'files',
            promise: this.$refs.serviceRecordFileUpload.handleUpload(),
          })
        }

        // 並行執行
        const settled = await Promise.all(uploadTasks.map((t) => t.promise))

        // 依型別安全指派
        const payload = { images: [], files: [] }
        uploadTasks.forEach((task, idx) => {
          payload[task.type] = settled[idx] || []
        })

        // 合併結果
        const images = [...new Set([...oldImages, ...(payload.images || [])])]
        const files = payload.files || []

        // 既有的文件資料＋新上傳的文件檔案
        const external_files = [...this.serviceRecordExternalWithoutCache.map((item) => ({ name: item.name, path: item.path })), ...this.mapExternalFiles(files)]

        // 組裝請求資料
        const requestData = {
          images,
          external_files,
          questions: this.serviceRecordSubmitData.questions,
          content: this.serviceRecordSubmitData.content,
        }

        // 判斷是新增還是編輯
        if (this.serviceRecordSubmitData.uuid) {
          // 編輯：使用 PATCH
          await updateHotelOrderPetComment(orderNo, this.petDetail.id, this.serviceRecordSubmitData.uuid, requestData)
          this.$message.success('服務紀錄已更新')
        } else {
          // 新增：使用 POST
          await createHotelOrderPetComment(orderNo, this.petDetail.id, requestData)
          this.$message.success('服務紀錄已新增')
        }
        this.isServiceRecordDrawerVisible = false
        this.removeServiceRecordExternalFile()
        await this.fetchServiceRecords()
        await this.fetchCurrentServiceRecords()
      } catch (error) {
        console.error(error)
      } finally {
        this.serviceRecordTryingSave = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.pet-side-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;

  &__tabs {
    flex-shrink: 0;
    padding: 0 16px;
    border-bottom: 1px solid #e6e6e6;
  }

  &__content {
    flex: 1;
    overflow-y: auto;
    padding: 20px 48px;
    margin-bottom: 120px;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      background: #ddd;
      border-radius: 3px;

      &:hover {
        background: #ccc;
      }
    }
  }
}

.pet-info-section {
  min-height: 200px;
}

// 編輯模式樣式
.pet-info-edit {
  .pet-avatar-upload {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
  }

  .w-full {
    width: 100%;
  }

  .pet-questions-edit {
    margin-top: 32px;
    padding: 0;

    .section-title {
      margin-bottom: 20px;
    }

    .question-group {
      margin-bottom: 28px;

      &:last-child {
        margin-bottom: 0;
      }

      .question-label {
        font-size: 14px;
        font-weight: 500;
        color: #333;
        margin-bottom: 12px;
        display: block;
      }

      .question-checkboxes {
        display: flex;
        flex-wrap: wrap;
        gap: 24px 16px;
        line-height: 1.8;

        :global(.el-checkbox) {
          margin: 0;
          line-height: 1;
        }
      }

      .healthy-checkboxes {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px 16px;

        .checkbox-item {
          display: flex;
          align-items: center;

          :global(.el-checkbox) {
            margin: 0;
          }
        }

        @media (max-width: 768px) {
          grid-template-columns: repeat(2, 1fr);
        }
      }

      .healthy-notice {
        margin-bottom: 12px;
        padding: 12px;
        background: #fff3cd;
        border-left: 4px solid #ffc107;
        border-radius: 4px;
        font-size: 13px;
        color: #856404;
        line-height: 1.6;
      }

      .healthy-other-input {
        margin-top: 12px;

        :global(.el-textarea__inner) {
          font-size: 14px;
        }
      }

      .extra-input-row {
        margin-top: 12px;
        display: flex;
        gap: 12px;

        .extra-input-item {
          flex: 1;

          :global(.el-input__inner) {
            font-size: 14px;
          }
        }
      }

      .simple-input-row {
        display: flex;
        gap: 12px;
        align-items: center;

        .simple-input-item {
          display: flex;
          align-items: center;
          gap: 8px;
          width: 100%;

          :global(.el-checkbox) {
            margin: 0;
            flex-shrink: 0;
          }

          :global(.el-input) {
            flex: 1;
          }

          :global(.el-input__inner) {
            font-size: 14px;
          }
        }
      }

      .behavior-list {
        display: flex;
        flex-direction: column;
        gap: 8px;

        .behavior-row {
          display: flex;
          align-items: center;
          gap: 8px;

          :global(.el-checkbox) {
            margin: 0;
            flex-shrink: 0;
          }

          .behavior-input {
            flex: 1;
            :global(.el-input__inner) {
              font-size: 14px;
            }
          }
        }
      }

      .behavior-items {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;

        .behavior-item {
          display: flex;
          align-items: center;
          gap: 8px;

          :global(.el-checkbox) {
            margin: 0;
            flex-shrink: 0;
          }

          .behavior-input {
            flex: 1;
            :global(.el-input__inner) {
              font-size: 14px;
            }
          }
        }

        @media (max-width: 768px) {
          grid-template-columns: 1fr;
        }
      }

      .question-radios {
        display: flex;
        gap: 24px;
        line-height: 1.8;

        :global(.el-radio) {
          margin: 0;
        }
      }
    }
  }
}

.pet-info-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 14px;
}

// 顯示模式樣式
.pet-info-display {
  .pet-avatar-container {
    width: 80px;
    height: 80px;
    background-size: cover;
    background-position: center;
    background-color: #eee;
    border-radius: 50%;
    flex-shrink: 0;
    overflow: hidden;
  }

  .pet-info-header {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 20px;
    background: #f9f9fb;
    border-radius: 8px;
    margin-bottom: 24px;

    .pet-info-basic {
      flex: 1;

      .pet-name {
        font-size: 20px;
        font-weight: 600;
        color: #333;
        margin-bottom: 4px;
      }

      .pet-category {
        font-size: 14px;
        color: #666;
      }
    }
  }

  .pet-info-details {
    .info-item {
      margin-bottom: 20px;

      .info-label {
        font-size: 13px;
        font-weight: 500;
        color: #666;
        margin-bottom: 6px;
      }

      .info-value {
        font-size: 15px;
        color: #333;
        line-height: 1.6;
        word-break: break-word;

        .info-detail-note {
          margin-top: 10px;
          padding-top: 10px;
          border-top: 1px solid #f0f0f0;
          font-size: 14px;
          line-height: 1.6;
          color: #666;
        }

        .behavior-display {
          display: flex;
          flex-direction: column;
          gap: 10px;

          .behavior-display-item {
            display: flex;
            gap: 12px;
            background: #f9f9fb;
            border-radius: 4px;

            .behavior-label {
              font-size: 14px;
              font-weight: 500;
              color: #333;
              min-width: 80px;
            }

            .behavior-detail {
              font-size: 14px;
              line-height: 1.6;
              color: #666;
              flex: 1;
            }
          }
        }
      }
    }
  }
}

.section-title {
  font-size: 17px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
}

.pet-question-card,
.pet-note-card {
  margin-top: 20px;
  padding: 16px;
  background: #f9f9fb;
  border-radius: 8px;
}

.pet-question-grid {
  .info-item {
    margin-bottom: 8px;

    .info-value {
      white-space: pre-wrap;
    }
  }
}

.pet-note-card {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }
}

.pet-note-section {
  margin-top: 20px;

  .pet-note-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  .note-edit-form {
    margin-bottom: 20px;
    padding: 16px;
    background: #f9f9fb;
    border-radius: 8px;
  }

  .notes-list {
    min-height: 100px;

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .note-item {
      line-height: 1.65;
      background: #fff;
      border-radius: 0px 20px 20px 20px;
      padding: 1.125rem 1.25rem;
      margin-bottom: 1.25rem;

      &:last-child {
        margin-bottom: 0;
      }

      .note-content {
        font-size: 14px;
        color: #333;
        white-space: pre-wrap;
        word-break: break-word;
      }

      .note-meta {
        font-size: 12px;
        color: #999;
        margin-top: 8px;
      }

      .note-actions {
        display: flex;
        gap: 8px;

        :global {
          .el-button--text {
            padding: 0;
            color: #409eff;

            &:hover {
              color: #66b1ff;
            }
          }
        }
      }
    }

    .no-notes {
      padding: 20px;
      text-align: center;
      color: #999;
      font-size: 14px;
    }
  }
}

.note-content {
  font-size: 14px;
  color: #333;
  white-space: pre-wrap;
  word-break: break-word;
}

// 服務紀錄樣式
.service-records,
.current-service-records {
  min-height: 300px;

  .service-records-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .section-title {
      font-size: 17px;
      font-weight: 600;
      color: #333;
      margin: 0;
    }
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;

  .empty-icon {
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.5;
  }

  .empty-text {
    font-size: 14px;
    color: #999;
  }
}

.records-list {
  .record-item {
    padding: 16px;
    background: #ffffff;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }

    .note-edit-form {
      margin-bottom: 12px;
      padding: 12px;
      background: #f9f9fb;
      border-radius: 8px;
    }

    .record-content {
      font-size: 14px;
      color: #333;
      line-height: 1.6;
      margin-bottom: 12px;

      &.record-content--question {
        padding: 10px 12px;
        background: #fff8f0;
        border-left: 3px solid #ea6a2a;
        border-radius: 4px;
        font-weight: 500;
      }
    }

    .record-images {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-bottom: 12px;

      .record-image {
        width: 80px;
        height: 80px;
        border-radius: 4px;
        cursor: pointer;
      }
    }

    .record-files {
      .record-file {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px;
        background: #fff;
        border-radius: 4px;
        margin-bottom: 4px;

        i {
          color: #ea6a2a;
          font-size: 16px;
        }

        .file-name {
          flex: 1;
          font-size: 13px;
          color: #ea6a2a;
          text-decoration: none;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    .record-footer {
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;

      .record-meta {
        font-size: 12px;
        color: #999;
      }

      .record-actions {
        display: flex;
        gap: 8px;
      }
    }
  }
}

// Drawer 样式
.custom-drawer-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  display: flex;
  justify-content: flex-end;
}

.drawer-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.drawer-container {
  position: relative;
  width: 45%;
  min-width: 500px;
  height: 100%;
  background: #f9f9fb;
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  z-index: 11;
}

.drawer-custom-header {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #f2f2f2;
  background: #f9f9f9;
  flex-shrink: 0;

  .close-btn {
    font-size: 32px;
    cursor: pointer;
    margin-right: 15px;
    color: #121931;

    &:hover {
      color: #ea6a2a;
    }
  }

  .header-title {
    color: #000000;
    font-weight: 900;
    font-size: 18px;
  }
}

// Drawer 动画
.drawer-fade-enter-active,
.drawer-fade-leave-active {
  transition: opacity 0.3s;

  .drawer-container {
    transition: transform 0.3s ease;
  }
}

.drawer-fade-enter,
.drawer-fade-leave-to {
  opacity: 0;

  .drawer-container {
    transform: translateX(100%);
  }
}

:global {
  .el-checkbox-group {
    .is-show {
      font-size: 12px;
    }
  }

  .sp-ck {
    margin-right: 0;
  }

  .inline-ck {
    display: flex;
    justify-content: flex-start;

    .sp-ck {
      width: auto;
    }
  }

  .inline-ck-item {
    display: flex;
    align-items: center;
    margin-left: 25px;
    width: 100%;
    flex-wrap: wrap;
  }
}

.afterCosmetic {
  overflow-x: scroll;

  :global {
    .el-form-item__content {
      width: 575px;
      max-width: 100%;
    }
  }
}

.btn-group-inline {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 20px;
  padding: 16px 0;
  border-top: 1px solid #f0f0f0;
}
</style>
